import React, { useState }from 'react';
import { useSelector, useDispatch } from "react-redux";
import { resetPagination } from 'reducers/paginationArticlesSlice';
import { setFilters, resetFilters } from 'reducers/filtersArticlesSlice';
import { useTranslation } from "react-i18next" 
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import ColorSettings  from "pages/settings/ColorSettings";
import TypesOfPrices from"pages/settings/TypesOfPricesSettings";
import TypesOfUnits from"pages/settings/TypesOfUnitsSettings"; 
import TypesOfTaxes from"pages/settings/TypesOfTaxesSettings";
import TypesOfSizes from"pages/settings/TypesOfSizesSettings";
import DepartmentSettings from "pages/commonsarticle/departmentSettings/DepartmentSettings";
import ArticleFilter from "pages/articles/articlesFilterList/ArticlesFilter";

const HomeArticle = () => {
    const {t,i18n} = useTranslation(['listDataArticles']);
    const dispatch = useDispatch();
    const filtersArticleDetails = useSelector((state) => state.filtersArticles); // Obtener filtros desde Redux
    const enabled = useSelector((state) => state.loginUser.enabled);
    const roles = useSelector((state) => state.loginUser.roles);  
    const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalColorSettings, setShowModalColorSettings] = useState(false);
    const [showModalTypesOfPrices, setShowModalTypesOfPrices] = useState(false);
    const [showModalTypesOfUnit,setShowModalTypesOfUnit] = useState(false); 
    const [showModalTypesOfTaxes,setShowModalTypesOfTaxes] = useState(false);
    const [showDepartmentSettings, setShowModalDepartmentSettings] = useState(false);
    const [showPrincipalMenu, setShowPrincipalMenu] = useState(true); 
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalDriverSettings, setShowModalDriverSettings] = useState(true);
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(true); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(true); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
    const [showModalTypesOfSizes,setShowModalTypesOfSizes] = useState(false);
    const showExtendedFilter = !!roles?.[0]?.listmenus?.find((key) => key.name === "Handle_Article_View_Extemded");
  
    const scriptUrl = '/js/sb-admin-2.min.js'; 

    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ 
                titleesFrom:"",
                titleesTo:"",
                salesunitsFromES:"",
                salesunitsToES:"",
                departmentFromES:"",
                departmentToES:"",
                sectionFromES:"",
                sectionToES:"",
                subsectionFromES:"",
                subsectionToES:""
            }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ 
                titleenFrom:"",
                titleenTo:"",
                salesunitsFromEN:"",
                salesunitsToEN:"",
                departmentFromEN:"",
                departmentToEN:"",
                sectionFromEN:"",
                sectionToEN:"",
                subsectionFromEN:"",
                subsectionToEN:"",
            }));
        }
    };
   
    const closeModalStores = () => {    
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(true);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(showModalGeneralSettings);
        setShowPrincipalMenu(showPrincipalMenu);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalDriverSettings(showModalDriverSettings);
        setShowModalStoreSettings(showModalStoreSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        dispatch(resetPagination());
        dispatch(resetFilters());
        return () => {};
      };

    function openModaColorsSettings(){
        setIndexShowSettings(1);
        setShowModalColorSettings(true);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfPriceSettings(){
        setIndexShowSettings(25);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(true);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
 
   function openModaSalesUnitsSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(true); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
    
    function openModaTypesOfTaxSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(true);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
 
    function openModaDepartmentSettings(){
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(false);
        setShowModalDepartmentSettings(true);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }

      function openModaTypesOfSizeSettings(){
         setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false); 
        setShowModalTypesOfTaxes(false);
         setShowModalTypesOfSizes(true);
        setShowModalDepartmentSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowPrincipalMenu(false);
    }
   
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer></ToastContainer>
        {enabled===false ? <Navigate to="/"/>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary sidebar toggled sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/article">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>

                    <div className={filtersArticleDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersArticleDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.idFrom}
                    </li>
                    <div className={filtersArticleDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersArticleDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.idTo}
                    </li>

                    <div className={(filtersArticleDetails.titleenFrom==='' && filtersArticleDetails.titleesFrom==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_titleFrom')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.titleenFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.titleenFrom:filtersArticleDetails.titleesFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.titleesFrom}
                    </li>
                    <div className={(filtersArticleDetails.titleenTo==='' && filtersArticleDetails.titleesTo==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_titleTo')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.titleenTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.titleenTo:filtersArticleDetails.titleesTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.titleesTo}
                    </li>

                    <div className={filtersArticleDetails.owncodeFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_owncodeFrom')}
                    </div>
                    <li className={filtersArticleDetails.owncodeFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.owncodeFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.owncodeFrom}
                    </li>
                    <div className={filtersArticleDetails.owncodeTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_owncodeTo')}
                    </div>
                    <li className={filtersArticleDetails.owncodeTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.owncodeTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.owncodeTo}
                    </li>
                    <div className={filtersArticleDetails.codeanFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_codeanFrom')}
                    </div>
                    <li className={filtersArticleDetails.codeanFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.codeanFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.codeanFrom}
                    </li>
                    <div className={filtersArticleDetails.codeanTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_codeanTo')}
                    </div>
                    <li className={filtersArticleDetails.codeanTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.codeanTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.codeanTo}
                    </li>

                    <div className={filtersArticleDetails.barcodeFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_barcodeFrom')}
                    </div>
                    <li className={filtersArticleDetails.barcodeFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.barcodeFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.barcodeFrom}
                    </li>
                    <div className={filtersArticleDetails.barcodeTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_barcodeTo')}
                    </div>
                    <li className={filtersArticleDetails.barcodeTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.barcodeTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.barcodeTo}
                    </li>

                     <div className={filtersArticleDetails.accountingcodeFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_accountingcodeFrom')}
                    </div>
                    <li className={filtersArticleDetails.accountingcodeFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.accountingcodeFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.accountingcodeFrom}
                    </li>
                    <div className={filtersArticleDetails.accountingcodeTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_accountingcodeTo')}
                    </div>
                    <li className={filtersArticleDetails.accountingcodeTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersArticleDetails.accountingcodeTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.accountingcodeTo}
                    </li>

                    {showExtendedFilter && 
                        <>
                            <div className={filtersArticleDetails.locationFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                                {t('Text_Filter_locationFrom')}
                            </div>
                            <li className={filtersArticleDetails.locationFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersArticleDetails.locationFrom==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.locationFrom}
                            </li>
                            <div className={filtersArticleDetails.locationTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                                {t('Text_Filter_mmodeloTo')}
                            </div>
                            <li className={filtersArticleDetails.locationTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersArticleDetails.locationTo==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.locationTo}
                            </li>
                        </>
                    }
                    <div className={(filtersArticleDetails.salesunitsFromEN==='' && filtersArticleDetails.salesunitsFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_salesunitsFrom')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.salesunitsFromEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.salesunitsFromEN:filtersArticleDetails.salesunitsFromES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.salesunitsFromES}
                    </li>
                    <div className={(filtersArticleDetails.salesunitsToEN==='' && filtersArticleDetails.salesunitsToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_salesunitsTo')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.salesunitsToEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.salesunitsToEN:filtersArticleDetails.salesunitsToES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.salesunitsToES}
                    </li>
                    <div className={(filtersArticleDetails.departmentFromEN==='' && filtersArticleDetails.departmentFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_departmentFrom')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.departmentFromEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.departmentFromEN:filtersArticleDetails.departmentFromES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.departmentFromES}
                    </li>
                    <div className={(filtersArticleDetails.departmentToEN==='' && filtersArticleDetails.departmentToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_departmentTo')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.departmentToEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.departmentToEN:filtersArticleDetails.departmentToES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.departmentToES}
                    </li>
                    <div className={(filtersArticleDetails.sectionFromEN==='' && filtersArticleDetails.sectionFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_sectionFrom')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.sectionFromEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.sectionFromEN:filtersArticleDetails.sectionFromES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.sectionFromES}
                    </li>
                    <div className={(filtersArticleDetails.sectionToEN==='' && filtersArticleDetails.sectionToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_sectionTo')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.sectionToEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.sectionToEN:filtersArticleDetails.sectionToES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.sectionToES}
                    </li>
                    <div className={(filtersArticleDetails.subsectionFromEN==='' && filtersArticleDetails.subsectionFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_subsectionFrom')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.subsectionFromEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.subsectionFromEN:filtersArticleDetails.subsectionFromES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.subsectionFromES}
                    </li>
                    <div className={(filtersArticleDetails.subsectionToEN==='' && filtersArticleDetails.subsectionToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_subsectionTo')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersArticleDetails.subsectionToEN==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.subsectionToEN:filtersArticleDetails.subsectionToES==='' ? t('Text_Filter_Not_Apply'): filtersArticleDetails.subsectionToES}
                    </li>
                    
                    {showExtendedFilter &&
                        <>
                            <li className="sidebar-heading text-warning">
                                &nbsp;
                            </li>
                            <div className={!filtersArticleDetails.applytypesofsize?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.applytypesofsize)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_applytypesofsize')}
                            </div>
                            <div className={!filtersArticleDetails.notapplytypesofsize?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.notapplytypesofsize)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_notapplytypesofsize')}
                            </div>
                            <li className="sidebar-heading text-warning">
                            &nbsp;
                            </li>
                            <div className={!filtersArticleDetails.applycolor?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.applycolor)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_applycolor')}
                            </div>
                            <div className={!filtersArticleDetails.notapplycolor?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.notapplycolor)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_notapplycolor')}
                            </div>
                            <li className="sidebar-heading text-warning">
                            &nbsp;
                            </li>

                            <div className={!filtersArticleDetails.applynumserial?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.applynumserial)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_applynumserial')}
                            </div>
                            <div className={!filtersArticleDetails.notapplycolor?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.notapplynumserial)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_applynotnumserial')}
                            </div>
                            <li className="sidebar-heading text-warning">
                            &nbsp;
                            </li>

                            <div className={!filtersArticleDetails.isnewpiece?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.isnewpiece)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_isnewpiece')}
                            </div>
                            <div className={!filtersArticleDetails.notisnewpiece?"sidebar-heading":"sidebar-heading text-white"}>
                                <i className="fas fa-solid fa-circle" style={{color:(filtersArticleDetails.notisnewpiece)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_notisnewpiece')}
                            </div>
                        </>
                    }
                     <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    
                    {/* Divider */}
                    <hr className="sidebar-divider"/>
                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))?
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/article" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Colors"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaColorsSettings}>{t('SubMenu_Settings_Type_Colors')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_Type_Colors')} </Link>}              
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfPrice"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaTypesOfPriceSettings}>{t('SubMenu_Settings_Type_Prices')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_Type_Prices')} </Link>}              
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfUnit"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaSalesUnitsSettings}>{t('SubMenu_Settings_SalesUnits')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_SalesUnits')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfSize"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaTypesOfSizeSettings}>{t('SubMenu_Settings_TypesOfSizes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_TypesOfSizes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfTax"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaTypesOfTaxSettings}>{t('SubMenu_Settings_TypesOfTaxes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_TypesOfTaxes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Department"))?
                                    <Link className="collapse-item"  to="/article" onClick={openModaDepartmentSettings}>{t('SubMenu_Settings_Departments')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/article">{t('SubMenu_Settings_Departments')} </Link>}
                                    <Link className="collapse-item" to="/article" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                </div>
                            </div>
                        </li>:
                        <li className="nav-item" style={{ textDecorationLine: 'line-through' }}>
                            <Link className="nav-link" to="/home">
                            <SettingsIcon/>
                                <span > {t('Menu_Settings')}</span>
                            </Link>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalStores}>
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>      
                                
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}
                
                {/* Show Modals */} 
                <ArticleFilter  
                    showModalArticlesSettings={showModalArticlesSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings} 
                /> 
                <ColorSettings  
                    showModalColorSettings={showModalColorSettings}
                    setShowModalColorSettings={setShowModalColorSettings}
                    setIndexShowSettings={setIndexShowSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfPrices                  
                    showModalTypesOfPrices={showModalTypesOfPrices}
                    setShowModalTypesOfPrices={setShowModalTypesOfPrices}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings} 
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfUnits   
                    showModalTypesOfUnit={showModalTypesOfUnit}
                    setShowModalTypesOfUnit={setShowModalTypesOfUnit}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <TypesOfSizes  
                    showModalTypesOfSizes={showModalTypesOfSizes} 
                    setShowModalTypesOfSizes={setShowModalTypesOfSizes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true} 
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                 <TypesOfTaxes   
                    showModalTypesOfTaxes={showModalTypesOfTaxes} 
                    setShowModalTypesOfTaxes={setShowModalTypesOfTaxes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true} 
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                 
                <DepartmentSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    showDepartmentSettings={showDepartmentSettings} 
                    setShowModalDepartmentSettings={setShowModalDepartmentSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={true}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeArticle;
